import React, { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useLocalStorage from "../../common/hooks/useLocalStorage";
import { LOCAL_STORAGE_KEYS } from "../../common/consts";

const HubSpotRedirect: FC = () => {
  const [, setHubspotAuthCode] = useLocalStorage(
    LOCAL_STORAGE_KEYS.hubspotAuthCode,
    ""
  );
  const [, setHubspotRedirectUri] = useLocalStorage(
    LOCAL_STORAGE_KEYS.hubspotRedirectUri,
    ""
  );

  const { search } = useLocation();

  const code = new URLSearchParams(search).get("code");

  useEffect(() => {
    // Get the code from the URL and close the window
    if (code) {
      setHubspotAuthCode(code);
      // Store the redirect URI that was used (base URL without query params)
      // Normalize it to match what was sent in the auth URL (remove trailing slash if not root)
      let redirectUri = `${window.location.origin}${window.location.pathname}`;
      if (redirectUri !== `${window.location.origin}/` && redirectUri.endsWith('/')) {
        redirectUri = redirectUri.slice(0, -1);
      }
      // Store as plain string, not JSON stringified
      setHubspotRedirectUri(redirectUri);
      console.log("HubSpot OAuth callback received:", { code, redirectUri });
      window.close();
      // If window.close() fails (not a popup), do a full page reload to dashboard
      setTimeout(() => { window.location.href = "/app/dashboard"; }, 1000);
    } else {
      // Check for error in URL
      const error = new URLSearchParams(search).get("error");
      if (error) {
        console.error("HubSpot OAuth error:", error);
        alert(`HubSpot authentication failed: ${error}`);
        window.close();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, search]);

  return (
    <div className="d-flex h-100 align-items-center justify-content-center m-auto">
      <div
        className="btn btn-light"
        onClick={() => {
          window.close();
        }}
      >
        <i className="fa-solid fa-times" /> Close
      </div>
    </div>
  );
};

export default HubSpotRedirect;
